<script setup lang="ts">
withDefaults(defineProps<{
  color?: string
  flat?: boolean
  density?: 'default' | 'comfortable' | 'compact'
  elevation?: number | string
  fixed?: boolean
}>(), {
  density: 'default',
})

const slots = defineSlots<{
  default(): any
  extension(): any
}>()
</script>

<template>
  <header
    class="m-app-bar"
    :class="[
      `m-app-bar--${density}`,
      {
        'm-app-bar--flat': flat || elevation === 0 || elevation === '0',
        'm-app-bar--fixed': fixed,
        'm-app-bar--has-extension': !!slots.extension,
      }
    ]"
  >
    <div class="m-app-bar__content">
      <slot />
    </div>
    <div v-if="slots.extension" class="m-app-bar__extension">
      <slot name="extension" />
    </div>
  </header>
</template>

<style scoped>
.m-app-bar {
  display: flex;
  flex-direction: column;
  background: var(--m-surface);
  box-shadow: var(--m-shadow-sm);
  z-index: var(--m-z-sticky);
  width: 100%;
}

.m-app-bar__content {
  display: flex;
  align-items: center;
  gap: var(--m-space-2);
  width: 100%;
  padding: 0 var(--m-space-4);
}

/* Heights apply to the content row */
.m-app-bar--default .m-app-bar__content { min-height: var(--m-appbar-height, 64px); }
.m-app-bar--comfortable .m-app-bar__content { min-height: 56px; }
.m-app-bar--compact .m-app-bar__content { min-height: 48px; }

.m-app-bar--flat { box-shadow: none; }
.m-app-bar--fixed { position: fixed; top: 0; left: 0; right: 0; }

.m-app-bar__extension {
  width: 100%;
}
</style>
